module.exports = __webpack_public_path__ + "img/11lastpts.b9761e05.png";